$(function () {
  var $body = $('body');
  //var urltag = new URLSearchParams(window.location.search);
  //var currentbaseurl = window.location.origin;

  completePageLoad();
  init();

  function completePageLoad() {
    $('.pg-page').removeClass('pg-page--loading');
  }
  function init() {
    console.log('pgterminal: welcome');
    $body.addClass('pg-page--welcome');
  }

  // Runs on product page
  if ($('body').hasClass('template-product')) {
    // Load all vimeo video campaigns
    document.querySelectorAll('.vimeo-campaign').forEach(function (video) {
      let video_url = video.dataset.url;
      fetch('https://vimeo.com/api/oembed.json?url=' + video_url + '?allow=autoplay&autoplay=1&muted=1&controls=true&responsive=true&muted=true&loop=true&background=true')
      .then(function (prom) {
        return prom.json()
      })
      .then(function(res) {
        video.insertAdjacentHTML('afterbegin', res.html)
      })
      .catch(function (e) {
        console.log(e)
      });
    });
  }

  if ($('body').hasClass('template-collection')) {
    // Load all vimeo video campaigns
    document.querySelectorAll('.vimeo-campaign').forEach(function (video) {
      let video_url = video.dataset.url;
      fetch('https://vimeo.com/api/oembed.json?url=' + video_url + '?allow=autoplay&autoplay=1&muted=1&controls=true&responsive=true&muted=true&loop=true&background=true')
      .then(function (prom) {
        return prom.json()
      })
      .then(function(res) {
        video.insertAdjacentHTML('afterbegin', res.html)
      })
      .catch(function (e) {
        console.log(e)
      });
    });
  }

  if ($('body').hasClass('template-index')) {
    // Load all vimeo video campaigns
    document.querySelectorAll('.vimeo-campaign').forEach(function (video) {
      let video_url = video.dataset.url;
      fetch('https://vimeo.com/api/oembed.json?url=' + video_url + '?allow=autoplay&autoplay=1&muted=1&controls=true&responsive=true&muted=true&loop=true&background=true')
      .then(function (prom) {
        return prom.json()
      })
      .then(function(res) {
        video.insertAdjacentHTML('afterbegin', res.html)
      })
      .catch(function (e) {
        console.log(e)
      });
    });
  }


  // Event listener for clicking a look item
  $('.pg-shop-the-look-toggle').on('click', function() {
    // Find the closest '.pg-shop-the-look-item' parent
    const parentItem = $(this).closest('.pg-shop-the-look-item');

    // Get the index from the parent '.pg-shop-the-look-item'
    const index = parentItem.data('index');

    $(".pg-shop-the-look-feed").toggleClass("pg-shop-the-look-feed--hide");
    $(".pg-text-intro-container").toggleClass("pg-text-intro-container--open");

    // Toggle 'open' class on the parent item and related information item
    parentItem.toggleClass('pg-shop-the-look-item--open');
    $(`.pg-shop-the-look-information-item[data-index="${index}"]`).toggleClass('pg-shop-the-look-information-item--open');
  });

  // Event listener for hovering over a look toggle
  $('.pg-shop-the-look-hover-toggle').on('mouseenter', function() {
    // Find the closest '.pg-shop-the-look-item' parent
    const parentItem = $(this).closest('.pg-shop-the-look-item');

    // Get the index from the parent '.pg-shop-the-look-item'
    const index = parentItem.data('index');

    // Add the hover class to the related information item
    $(`.pg-shop-the-look-information-item[data-index="${index}"]`).addClass('pg-shop-the-look-information-item--hover');
    $(".pg-shop-the-look-introduction-container").addClass("pg-shop-the-look-introduction-container--close");
  });

  $('.pg-shop-the-look-hover-toggle').on('mouseleave', function() {
    // Find the closest '.pg-shop-the-look-item' parent
    const parentItem = $(this).closest('.pg-shop-the-look-item');

    // Get the index from the parent '.pg-shop-the-look-item'
    const index = parentItem.data('index');

    // Remove the hover class from the related information item
    $(`.pg-shop-the-look-information-item[data-index="${index}"]`).removeClass('pg-shop-the-look-information-item--hover');
    $(".pg-shop-the-look-introduction-container").removeClass("pg-shop-the-look-introduction-container--close");
  });

  // Shop the look mobile toggle
  // Event listener for clicking a look item
  $('.pg-shop-the-look-toggle-mobile').on('click', function() {
    // Find the closest '.pg-shop-the-look-item' parent
    const parentItem = $(this).closest('.pg-shop-the-look-item-mobile');

    $(".pg-page").toggleClass("pg-page--shop-the-look-open");

    // Toggle 'open' class on the parent item and related information item
    parentItem.toggleClass('pg-shop-the-look-item-mobile--open');
  });

  //  Back to top button
  $('body').on('click', '.js-scroll-to-top', function(e) {
    $('html, body').animate({
      scrollTop: $(".pg-page").offset().top
    }, 800);
    e.preventDefault();
  });

  $('.main-carousel').slick({
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: true,
    dots: false,
    autoplay: false,
    adaptiveHeight: false,
    arrows: false,
    touchThreshold: 100,
    useCSS: false,
    useTransform: false,
    asNavFor: '.zoom-carousel'
  });

  function initializeSlick() {
    $('.zoom-carousel').slick({
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      dots: false,
      autoplay: false,
      adaptiveHeight: true,
      arrows: true,
      prevArrow: $('.prev'),
      nextArrow: $('.next'),
      touchThreshold: 100,
      useCSS: false,
      useTransform: false,
      asNavFor: '.main-carousel'
    });
  }

  initializeSlick();

  // Desktop zoom toggle
  $('body').on('click', '.pg-open-slider-zoom-desktop', function(e) {
    e.preventDefault();
  
    const index = $(this).data('index') - 1;
    const $zoomContainer = $('.pg-slider-zoom-container');
  
    // Hide from DOM completely (no rendering = no visual transition)
    $zoomContainer.addClass('pg-slider-zoom-container--preload');
  
    // Ensure the correct slide is ready
    $('.zoom-carousel').slick('slickGoTo', index, false);
    $('.zoom-carousel').slick('setPosition');
  
    // Slight delay, then reveal container
    setTimeout(() => {
      $zoomContainer
        .removeClass('pg-slider-zoom-container--preload')
        .addClass('pg-slider-zoom-container--open');
  
      $('.pg-page').addClass('pg-page--zoom');
    }, 20); // Small timeout to allow DOM update
  });

  // Mobile zoom toggle
  $('body').on('click', '.pg-open-slider-zoom-mobile', function(e) {
      e.preventDefault();
      $(".pg-slider-zoom-container").addClass("pg-slider-zoom-container--open");
      $(".pg-page").addClass("pg-page--zoom");

      // Trigger the setPosition method to ensure images are loaded
      $('.zoom-carousel').slick('setPosition');
  });

  // Close zoom container
  $('body').on('click', '.pg-close-zoom', function(e) {
    e.preventDefault();
    $(".pg-zoom-container").removeClass("pg-zoom-container--open");
    $(".pg-slider-zoom-container").removeClass("pg-slider-zoom-container--open");
    $(".pg-page").removeClass("pg-page--zoom");
  });

  //  Collection dropdown toggle
  $('body').on('click', '#pg-shop-nav-toggle', function(e) {
    e.preventDefault();
    // @todo this naming isn't ideal
    $(".pg-shop-nav-mobile-drop-down").toggleClass("pg-shop-nav-mobile-drop-down--open");
  });

  $('body').on('click', '#pg-search-toggle', function(e) {
    e.preventDefault();
    $(".pg-search-popup").toggleClass("pg-search-popup--open");
    $(".pg-search-overlay").toggleClass("pg-search-overlay--open");
    $(".pg-page").toggleClass("pg-page--search-open");
    $(".pg-mobile-menu-container").removeClass("pg-mobile-menu-container--open");
    $(".pg-page").removeClass("pg-page--mobile-menu-open");
    var $input = $(".pg-search-input");
    $input.val('');
    $input.focus();
  });

  //  Mobile menu toggle
  $('body').on('click', '#pg-mobile-menu-toggle', function(e) {
    e.preventDefault();
    $(".pg-mobile-menu-container").toggleClass("pg-mobile-menu-container--open");
    $(".pg-page").toggleClass("pg-page--mobile-menu-open");
    $(".pg-search-popup").removeClass("pg-search-popup--open");
    $(".pg-page").removeClass("pg-page--search-open");
  });

  //  Shop menu toggle
  $('body').on('click', '#js-shop-menu-toggle', function(e) {
    e.preventDefault();
    $(".pg-mobile-menu-nav--shop").toggleClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--edit").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--footer").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--join-us").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--collective").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-title--join-us").removeClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--shop").toggleClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--edit").removeClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--footer").removeClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--collective").removeClass("pg-mobile-menu-title--open");
  });

  //  Edit menu toggle
  $('body').on('click', '#js-edit-menu-toggle', function(e) {
    e.preventDefault();
    $(".pg-mobile-menu-nav--edit").toggleClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--shop").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--footer").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--join-us").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--collective").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-title--join-us").removeClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--edit").toggleClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--shop").removeClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--footer").removeClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--collective").removeClass("pg-mobile-menu-title--open");
  });

  //  Collective menu toggle
  $('body').on('click', '#js-collective-menu-toggle', function(e) {
    e.preventDefault();
    $(".pg-mobile-menu-nav--collective").toggleClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--shop").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--footer").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--join-us").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--edit").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-title--join-us").removeClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--collective").toggleClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--shop").removeClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--footer").removeClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--edit").removeClass("pg-mobile-menu-title--open");
  });

  //  Footer menu toggle
  $('body').on('click', '#js-footer-menu-toggle', function(e) {
    e.preventDefault();
    $(".pg-mobile-menu-nav--footer").toggleClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--join-us").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--shop").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--edit").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--collective").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-title--join-us").removeClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--footer").toggleClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--shop").removeClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--edit").removeClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--collective").removeClass("pg-mobile-menu-title--open");
  });

  //  Join us menu toggle
  $('body').on('click', '#js-join-us-menu-toggle', function(e) {
    e.preventDefault();
    $(".pg-mobile-menu-nav--join-us").toggleClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--footer").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--shop").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--edit").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-nav--collective").removeClass("pg-mobile-menu-nav--open");
    $(".pg-mobile-menu-title--join-us").toggleClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--footer").removeClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--shop").removeClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--edit").removeClass("pg-mobile-menu-title--open");
    $(".pg-mobile-menu-title--collective").removeClass("pg-mobile-menu-title--open");
  });

  //  Sub menu toggle on mobile
  $('body').on('click', '.js-sizing-chart', function(e) {
    e.preventDefault();
    // @todo this naming isn't ideal
    $(".pg-size-chart-container").toggleClass("pg-size-chart-container--open");
    $(".pg-page").toggleClass("pg-page--size-chart-open");
  });

  //  Product page toggle
  $('body').on('click', '#pg-product-returns-toggle', function(e) {
    e.preventDefault();
    // @todo this naming isn't ideal
    $(".pg-info-container--returns").toggleClass("pg-info-container--open");
    $(".pg-info-container--preorder").removeClass("pg-info-container--open");
    $(".pg-info-container--shipping").removeClass("pg-info-container--open");
    $(".pg-info-container--payment").removeClass("pg-info-container--open");
    $(".pg-info-container--customercare").removeClass("pg-info-container--open");
    $(".pg-info-container--size").removeClass("pg-info-container--open");
  });

  $('body').on('click', '#pg-product-preorder-toggle', function(e) {
    e.preventDefault();
    // @todo this naming isn't ideal
    $(".pg-info-container--preorder").toggleClass("pg-info-container--open");
    $(".pg-info-container--returns").removeClass("pg-info-container--open");
    $(".pg-info-container--shipping").removeClass("pg-info-container--open");
    $(".pg-info-container--payment").removeClass("pg-info-container--open");
    $(".pg-info-container--customercare").removeClass("pg-info-container--open");
    $(".pg-info-container--size").removeClass("pg-info-container--open");
  });

  $('body').on('click', '#pg-product-shipping-toggle', function(e) {
    e.preventDefault();
    // @todo this naming isn't ideal
    $(".pg-info-container--shipping").toggleClass("pg-info-container--open");
    $(".pg-info-container--returns").removeClass("pg-info-container--open");
    $(".pg-info-container--preorder").removeClass("pg-info-container--open");
    $(".pg-info-container--payment").removeClass("pg-info-container--open");
    $(".pg-info-container--customercare").removeClass("pg-info-container--open");
    $(".pg-info-container--size").removeClass("pg-info-container--open");
  });

  $('body').on('click', '#pg-product-payment-toggle', function(e) {
    e.preventDefault();
    // @todo this naming isn't ideal
    $(".pg-info-container--payment").toggleClass("pg-info-container--open");
    $(".pg-info-container--returns").removeClass("pg-info-container--open");
    $(".pg-info-container--preorder").removeClass("pg-info-container--open");
    $(".pg-info-container--shipping").removeClass("pg-info-container--open");
    $(".pg-info-container--customercare").removeClass("pg-info-container--open");
    $(".pg-info-container--size").removeClass("pg-info-container--open");
  });

  $('body').on('click', '#pg-product-size-toggle', function(e) {
    e.preventDefault();
    // @todo this naming isn't ideal
    $(".pg-info-container--payment").removeClass("pg-info-container--open");
    $(".pg-info-container--returns").removeClass("pg-info-container--open");
    $(".pg-info-container--preorder").removeClass("pg-info-container--open");
    $(".pg-info-container--shipping").removeClass("pg-info-container--open");
    $(".pg-info-container--customercare").removeClass("pg-info-container--open");
    $(".pg-info-container--size").toggleClass("pg-info-container--open");
  });

  // $('body').on('click', '.pg-toggle-zoom', function(e) {
  //   e.preventDefault();
  //   $(".pg-zoom-container").toggleClass("pg-zoom-container--open");
  //   $(".pg-page").toggleClass("pg-page--zoom");
  // });
  //
  // $('body').on('click', '.pg-mobile-toggle-zoom', function(e) {
  //   e.preventDefault();
  //   $(".pg-slider-container-product--mobile").toggleClass("pg-slider-container-product--mobile-zoom");
  //   $(".pg-page").toggleClass("pg-page--zoom");
  // });

  //  Class added to page when scrolled
  //    - Used so that back to top button appears when scrolled
  $(window).scroll(function() {
    var s = $(".pg-page");
    var pos = s.position();

    if (s.length) {
      var windowpos = $(window).scrollTop();
      if (windowpos >= pos.top & windowpos <=0) {
        s.removeClass("pg-page--scrolled");
      } else {
        s.addClass("pg-page--scrolled");
      }
    }
  });

  //  Class added to page when reaching bottom of page
  $(window).scroll(function() {
     $(".pg-page").removeClass("pg-page--bottom");
     if ($(window).scrollTop() + $(window).height() > ($(document).height() - 100) ) {
       // At bottom
       $(".pg-page").addClass("pg-page--bottom");
     }
  });

  // $('body').on('mouseenter', '#pg-shop-menu-hover', function(e) {
  //   e.preventDefault();
  //   $(".pg-header-menu-dropdown--shop").addClass("pg-header-menu-dropdown--shop-open");
  //   $(".pg-header").addClass("pg-header--shop-open");
  // });
  // $('body').on('mouseleave', '#pg-shop-menu-hover', function(e) {
  //   e.preventDefault();
  //   $(".pg-header-menu-dropdown--shop").removeClass("pg-header-menu-dropdown--shop-open");
  //   $(".pg-header").removeClass("pg-header--shop-open");
  // });

  $('body').on('click', '#pg-mainmenu-menu-toggle', function(e) {
    e.preventDefault();
    $(".pg-header-menu-dropdown--shop").toggleClass("pg-header-menu-dropdown--shop-open");
    $(".pg-header").toggleClass("pg-header--shop-open");
  });

  // $('body').on('mouseenter', '#pg-edit-menu-hover', function(e) {
  //   e.preventDefault();
  //   $(".pg-header-menu-dropdown--edit").addClass("pg-header-menu-dropdown--edit-open");
  //   $(".pg-header").addClass("pg-header--edit-open");
  // });
  // $('body').on('mouseleave', '#pg-edit-menu-hover', function(e) {
  //   e.preventDefault();
  //   $(".pg-header-menu-dropdown--edit").removeClass("pg-header-menu-dropdown--edit-open");
  //   $(".pg-header").removeClass("pg-header--edit-open");
  // });
  //
  // $('body').on('mouseenter', '#pg-collective-menu-hover', function(e) {
  //   e.preventDefault();
  //   $(".pg-header-menu-dropdown--collective").addClass("pg-header-menu-dropdown--collective-open");
  //   $(".pg-header").addClass("pg-header--collective-open");
  // });
  // $('body').on('mouseleave', '#pg-collective-menu-hover', function(e) {
  //   e.preventDefault();
  //   $(".pg-header-menu-dropdown--collective").removeClass("pg-header-menu-dropdown--collective-open");
  //   $(".pg-header").removeClass("pg-header--collective-open");
  // });

  $('body').on('click', '#pg-thecollective-membership-toggle', function(e) {
    e.preventDefault();
    $(".pg-page-thecollective-account-menu-link").removeClass("active");
    $(this).addClass("active");
    $(".pg-accounts-personal-info-container--membership").addClass("pg-accounts-personal-info-container--show");
    $(".pg-accounts-personal-info-section--orderhistory").removeClass("pg-accounts-personal-info-container--show");
    $(".pg-accounts-personal-info-section--mydetails").removeClass("pg-accounts-personal-info-container--show");
    $(".pg-accounts-personal-info-section--addresses").removeClass("pg-accounts-personal-info-container--show");
  });

  $('body').on('click', '#pg-thecollective-orderhistory-toggle', function(e) {
    e.preventDefault();
    $(".pg-page-thecollective-account-menu-link").removeClass("active");
    $(this).addClass("active");
    $(".pg-accounts-personal-info-container--membership").removeClass("pg-accounts-personal-info-container--show");
    $(".pg-accounts-personal-info-section--orderhistory").addClass("pg-accounts-personal-info-container--show");
    $(".pg-accounts-personal-info-section--mydetails").removeClass("pg-accounts-personal-info-container--show");
    $(".pg-accounts-personal-info-section--addresses").removeClass("pg-accounts-personal-info-container--show");
  });

  $('body').on('click', '#pg-thecollective-mydetails-toggle', function(e) {
    e.preventDefault();
    $(".pg-page-thecollective-account-menu-link").removeClass("active");
    $(this).addClass("active");
    $(".pg-accounts-personal-info-container--membership").removeClass("pg-accounts-personal-info-container--show");
    $(".pg-accounts-personal-info-section--orderhistory").removeClass("pg-accounts-personal-info-container--show");
    $(".pg-accounts-personal-info-section--mydetails").addClass("pg-accounts-personal-info-container--show");
    $(".pg-accounts-personal-info-section--addresses").removeClass("pg-accounts-personal-info-container--show");
  });

  $('body').on('click', '#pg-thecollective-addresses-toggle', function(e) {
    e.preventDefault();
    $(".pg-page-thecollective-account-menu-link").removeClass("active");
    $(this).addClass("active");
    $(".pg-accounts-personal-info-container--membership").removeClass("pg-accounts-personal-info-container--show");
    $(".pg-accounts-personal-info-section--orderhistory").removeClass("pg-accounts-personal-info-container--show");
    $(".pg-accounts-personal-info-section--mydetails").removeClass("pg-accounts-personal-info-container--show");
    $(".pg-accounts-personal-info-section--addresses").addClass("pg-accounts-personal-info-container--show");
  });
});
